import { CHARACTERS_LIMIT_MPA_MESSAGE, URL_PLACEHOLDER } from '../../../Config/env';

export function MPACutter(text, prefixLength, hasImage) {
  const isShortMode = hasImage || (text.length + prefixLength) > CHARACTERS_LIMIT_MPA_MESSAGE;
  return isShortMode ? `Tap to view: ${URL_PLACEHOLDER}` : `${text}`;
}
